module.exports = __webpack_public_path__ + "img/msOffice.7606c647.png";